// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3UWvu","legacyBtn":"MutateMid_legacyBtn__3NJg0"};